import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './Styles.css';

/*
  NOTE: This is a structural template for Foundation.jsx.
  Keep your existing content/data — only replace:
    1. The section wrapper className
    2. The section-header block at the top
    3. Import the new Styles.css
  Do NOT change any backend calls or data fetching logic.
*/

const FoundationSchool = () => {
    const navigate = useNavigate();
  const [headingRef, headingVisible] = useScrollAnimation({ threshold: 0.2 });
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="foundation-section">
      <div className="container">

        {/* HEADER — default pattern: eyebrow LEFT · title RIGHT
            (alternates with AboutUs which is flip: title left, eyebrow right) */}
        <div
          ref={headingRef}
          className={`section-header fade-in-up ${headingVisible ? 'visible' : ''}`}
        >
          <div className="sh-label">
            <span className="eyebrow">Foundation School</span>
          </div>
          <div className="sh-title">
            <h2 className="section-title">WHAT IS THE AIM OF FOUNDATION SCHOOL?</h2>
          </div>
        </div>

        {/* ── Your existing content below — untouched ── */}
        <div
          ref={contentRef}
          className={`foundation-content fade-in-up ${contentVisible ? 'visible' : ''}`}
        >
          <div className="foundation-text">

            <h3>What You'll Learn</h3>
            <ul className="foundation-learn-list">
              <li>Build a strong foundation in Christian faith.</li>
              <li>Understand the vision, mission, and structure of the ministry.</li>
              <li>Discover your purpose and role in God's Kingdom.</li>
              <li>Develop consistent Bible study and spiritual disciplines.</li>
              <li>Grow through fellowship with believers and the Holy Spirit.</li>
              <li>Serve effectively in the local church and beyond.</li>
              <li>Prepare for greater responsibilities in ministry.</li>
            </ul>

            <h3>Build Your Faith on Solid Ground</h3>
            <p>
              The aim of the membership school is to educate the citizens of loveworld concerning the basic doctrines of Christ and lay a good foundation of Christianity and our ministry, which can be built upon to live an effective and fulfilling life.
            </p>

            <button className="foundation-btn" onClick={() => navigate('/foundation-course')}>Register Now</button>
          </div>

          <div className="foundation-modules">
            <div className="foundation-module-card">
              <h4>Module 1</h4>
              <p>The New Creation</p>
            </div>
            <div className="foundation-module-card">
              <h4>Module 2</h4>
              <p>The Holy Spirit</p>
            </div>
            <div className="foundation-module-card">
              <h4>Module 3</h4>
              <p>Christian Doctrine</p>
            </div>
            <div className="foundation-module-card">
              <h4>Module 4</h4>
              <p>Evangelism and Soul Winning</p>
            </div>
            <div className="foundation-module-card">
              <h4>Module 5</h4>
              <p>Christian Character and Prosperity</p>
            </div>
            <div className="foundation-module-card">
              <h4>Module 6</h4>
              <p>The Local Assembly and Loveworld Inc. (Christ Embassy)</p>
            </div>
            <div className="foundation-module-card" style={{ gridColumn: 'span 2' }}>
              <h4>Module 7</h4>
              <p>Introduction to Mobile Technology for Personal Growth, Evangelism and Church Growth</p>
            </div>
          </div>
        </div>
        {/* ── End of your existing content ── */}

      </div>
    </section>
  );
};

export default FoundationSchool;
